export const sortByDisplayOrder = (a, b) => {
  const orderA = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
  const orderB = b.displayOrder ?? Number.MAX_SAFE_INTEGER;

  return orderA - orderB;
};
